<template>
  <div class="layout">
    <svg width = "30%" height = "100%" id="rightOffsetBracket" ref="rightOffsetBracket" v-show="false">
      <rect
        x="0"
        y="0"
        width="100%"
        height="55"
        opacity=".45"
        fill="#f7f7f7"
      ></rect>
      <line
        :x1 = "width - 10"
        :x2 = "width - 20"
        :y1 = "60"
        :y2 = "60"
        :style = "sliderColor"
      />
      <line
        :x1 = "width - 10"
        :x2 = "width - 20"
        :y1 = "105"
        :y2 = "105"
        :style = "sliderColor"
      />
      <line
        :x1 = "width - 20"
        :x2 = "width - 20"
        :y1 = "60"
        :y2 = "105"
        :style = "sliderColor"
      />
      <line
        :x1 = "width - 20"
        :x2 = "0"
        :y1 = "82"
        :y2 = "82"
        :style = "sliderColor"
      />
    </svg>
  </div>
</template>

<script>
import { useInputStore } from '@/store/InputStore';
import { useSegmentStore } from '@/store/SegmentStore';
import { useSettingsStore } from '@/store/SettingsStore';
import * as UnitConversion from '@/services/UnitConversionService';
import NumericField from '@/components/nelson/NumericField';

export default {
  components: {
    NumericField
  },
  mounted () {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  unmounted () {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    getLengthUnit (to, from) {
      const inputStore = useInputStore();
      if (to != from) {
        if (to === 'ft') {
          inputStore.setPipeRightOffset(UnitConversion.ConvertMetersToFt(this.pipeRightOffset));
        } else {
          inputStore.setPipeRightOffset(UnitConversion.ConvertFtToMeters(this.pipeRightOffset));
        }
      }
    }
  },
  computed: {
    getLengthUnit () {
      return useSettingsStore().getLengthUnit;
    },
    pipeRightOffset: {
      get () {
        return useInputStore().getPipeRightOffset;
      },
      set (value) {
        useInputStore().setPipeRightOffset(parseInt(value));
      }
    },
    sliderColor () {
      return 'stroke:rgb(' + useSegmentStore().hexToRgb('#000000')  + ')';
    },
    width () {
      return useInputStore().getRightOffsetBracketWidth;
    },
  },
  methods: {
    handleResize () {
      useInputStore().setRightOffsetBracketWidth(this.$refs.rightOffsetBracket.clientWidth);
    },
  }
};
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: row;
  height: 110px;
  width: 100%;
}
.spacer {
  height: 50%;
}
.margin-label {
  height: 20%;
  user-select: none;
}
.chart-input {
  background-color: #EEEEEE;
  border-radius: 15px;
  height: 20%;
  text-align: center;
  user-select: none;
  width: 100%;
  border: none;
}
.chart-input-box {
  display: flex; 
  flex-direction: row; 
  align-items: center; 
  justify-content: space-between;
}
.tr-margin-block {
  width: 100%;
  height: 55px;
  background-color: rgba(247, 247, 247, 0.45);
}
.offset-r-holder {
  transform: translateX(-20px);
}
</style>